export const listProducts = `
   query listProducts($limit: Int, $nextToken: String) {
       listProducts(limit: $limit, nextToken: $nextToken) {
           items {
              id
              name
           }
           nextToken
       }
   }
`;

export const getProduct = `
   query getProduct($id:ID!) {
       getProduct(id:$id) {
         id
         name
       } 
}`;
